import api from './api';

export const dispatchApi = {
  queue: (params = {}) => api.get('/dispatch/queue', { params }),
  runs: (params = {}) => api.get('/dispatch/runs', { params }),
  showRun: (id) => api.get(`/dispatch/runs/${id}`),
  generateFreeBatch: (magazine_issue_id) =>
    api.post('/dispatch/generate-free-batch', { magazine_issue_id }),
  importOrders: (payload = {}) => api.post('/dispatch/import-orders', payload),
  markSlipsPrinted: (item_ids) =>
    api.post('/dispatch/mark-slips-printed', { item_ids }),
  printSlips: (item_ids) => api.post('/dispatch/print-slips', { item_ids }, { timeout: 120000 }),
  ship: (payload) => api.post('/dispatch/ship', payload),
  sendEmails: (item_ids) => api.post('/dispatch/send-emails', { item_ids }),
  updateItem: (id, data) => api.patch(`/dispatch/items/${id}`, data),
};

export const emailLogsApi = {
  list: (params = {}) => api.get('/email-logs', { params }),
};

export const emailNotificationsApi = {
  list: () => api.get('/email-notifications'),
  update: (enabled) => api.put('/email-notifications', { enabled }),
  preview: (purpose) => api.get(`/email-notifications/${encodeURIComponent(purpose)}/preview`),
  sendTest: (purpose, to) => api.post('/email-notifications/send-test', { purpose, to }),
};

export const pluginsApi = {
  get: () => api.get('/plugins'),
  update: (provider, fields) => api.put('/plugins', { provider, fields }),
  testMail: (to) => api.post('/plugins/test-mail', { to }),
  testSes: () => api.post('/plugins/test-ses'),
  testTcs: () => api.post('/plugins/test-tcs'),
  testLeopards: () => api.post('/plugins/test-leopards'),
  testJazzCash: () => api.post('/plugins/test-jazzcash'),
  syncLeopardsCities: () => api.post('/plugins/sync-leopards-cities'),
};

export const customersApi = {
  list: (params = {}) => api.get('/customers', { params }),
  update: (id, data) => api.patch(`/customers/${id}`, data),
  remove: (id) => api.delete(`/customers/${id}`),
  register: (data) => api.post('/customers/register', data),
  login: (data) => api.post('/customers/login', data),
};

export default dispatchApi;
